(ns assemble.component.drawer.hooks
  (:require [assemble.component.file-tree.hooks :refer [use-active-asset-type]]
            [assemble.resource.template :as template]
            [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-drawer-assets-data []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {file-id :file} (use-subscribe [:router/query-parameters])

        asset-type (use-active-asset-type)
        node-id (use-subscribe [:assemble.page.assets.file-tree/current-node-id])

        ;; TODO: Consider using linked/map to store the data by id
        fonts-data (use-subscribe [:assemble.resource.asset/fonts-by-node-and-advertiser-id node-id advertiser-id])
        assets-data (use-subscribe [:assemble.resource.asset/assets-by-node node-id])

        all-data (if (= :fonts asset-type)
                   fonts-data
                   assets-data)]
    (some (fn [x]
            (when (or (= file-id (:asset/id x)) (= file-id (:asset-tree/id x)))
              x))
          all-data)))

(defhook use-drawer-templates-data []
  (let [{:keys [file]} (use-subscribe [:router/query-parameters])
        current-node-id (use-subscribe [:assemble.page.assets.file-tree/current-node-id])
        templates (use-subscribe [::template/templates-by-node current-node-id])]
    (get templates file)))

(defhook use-drawer-folders-data []
  (let [{folder-id :folder} (use-subscribe [:router/query-parameters])
        {folder-name :asset-tree/name} (use-subscribe [:assemble.page.assets.file-tree/get-item folder-id])]
    {:folder-id folder-id
     :folder-name folder-name}))

(defhook use-drawer-font-family-data []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        state (use-subscribe [:assemble.resource.asset/state])
        families (get-in state [:font-families-by-advertiser advertiser-id])
        font-family (use-subscribe [:assemble.page.assets.file-tree/font-family])
        family (filter #(= (:font-family/display-name %) font-family)
                       families)]
    (if (empty? family)
      {:font-family/display-name font-family}
      (first family))))

(defhook use-drawer-open? [qp-key]
  (let [query-params (use-subscribe [:router/query-parameters])]
    (some? (get query-params qp-key))))
